import React from "react";
import Sidebar  from "../Sidebar/Sidebar";
import "./layout.scss";

const Layout = () => {
  return (
    <div>
 
        <Sidebar />
      
   

    </div>
  );
};

export default Layout;
